module.exports = __webpack_public_path__ + "back.07ad84b1.png";